import * as z from "zod";
import * as b from './baseSchemas';
export const SpecialityLevel = z.object({
    "level": b.qualityColor,
    "buff": z.array(b.Buff),
});
export const Speciality = z.object({
    "name": z.string(),
    "attribute": z.array(SpecialityLevel),
});
